<template>
  <v-container class="mt-4 d-flex flex-column" style="min-height: 90vh;">
    <h2 class="mb-6">Wunschdienstplan eingereicht</h2>

    <div class="mb-3">
      <span>Dein Wunschdienstplan wurde <span class="highlight">eingereicht!</span></span>
    </div>

    <div class="mb-3">
      <span>Bis zur Deadline <span class="highlight">{{ wishPeriod?.deadline.toLocaleDateString("de-DE") }}</span> kannst du den WDP noch anpassen!</span>
    </div>

    <div class="mb-3">
      <span>Es wird nun geprüft, in wie weit deine Wünsche <span class="highlight">berücksichtigt</span> werden können.</span>
    </div>

    <div class="mb-3">
      <span>Beachte, dass dieser Plan <span class="highlight">noch nicht bestätigt</span> ist!</span>
    </div>

    <div class="mb-3">
      <span>In der Zwischenzeit kannst du deine eingegebenen Wunschzeiten in der App oder deinen E-Mails <span class="highlight">einsehen.</span></span>
    </div>

    <div class="mb-3">
      <span>Sobald dein Dienstplan bearbeitet wurde, bekommst du eine <span class="highlight">Benachrichtigung.</span></span>
    </div>

    <v-container class="mt-auto" style="position: sticky; bottom: 0;" fluid>
      <div  class="mb-1 d-flex pa-0 justify-space-between flex-end">
        <v-btn  class="ma-0 flex-1-0-0" color="primary" @click="goToList">Zurück zur Startseite</v-btn>
      </div>
    </v-container>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import router from "@/router";
import {useRoute} from "vue-router";
import {GetWishPeriod} from "@/data/wishPeriod";
export default defineComponent({
  setup() {
    const route = useRoute();
    const wishPeriod = ref<WishPeriod | null | undefined>(null);
    
    onMounted(async () => {
      var wishPeriodId = route.params.id;
      wishPeriod.value = await GetWishPeriod(wishPeriodId);
    });
    const goToList = () => {
      router.push('/wuensche');
    };
    return {goToList, wishPeriod};
}});
</script>

<style scoped>
.highlight {
  color: var(--new-primary-beere);
}
</style>